import React, { useState } from "react";
import Corner from "./corner";
export default function Button({
  className = "",
  id,
  children,
  theme,
  isEnabled = true,
  isFocus = () => false, // 傳入函式確認是否為目前 focus
  onClick = () => {},
}) {
  const [hasFocus, setHasFocus] = useState(false); // local 聚焦狀態

  const isFocused = isFocus(id) || hasFocus;

  const css = () => {
    // return isSelectedItem(name) ? ` border-${theme}-on-focus ` : `  `
    return isFocused
      ? ` border-${theme}-on-focus border-thin opacity-80 placeholder-${theme}-focus focus:border-[3px] `
      : ` border-${theme}-normal border-thin border-gray-500 placeholder-${theme}-normal hover:border-[3px]  hover:border-${theme}-btn-hover hover:bg-${theme}-btn-hover hover:bg-opacity-30 `;
  };

  // const css = () => {
  //   return isFocused
  //     ? `border-${theme}-on-focus border-[5px] opacity-80 placeholder-${theme}-focus bg-${theme}-btn-focus`
  //     : `bg-${theme}-btn-disabled border-[0px] placeholder-${theme}-normal hover:border-[3px]`;
  // };

  const handleClick = (e) => {
    e.stopPropagation();
    onClick(e);
  };
  return (
    <>
      <button
        id={id}
        data-id={id}
        type="button"
        tabIndex={0}
        disabled={!isEnabled}
        onClick={handleClick}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onKeyDown={(e) => {
          if (e.key === "Enter") onClick(e);
        }}
        className={`${className} corner-outline rounded-md button-text px-4 
            ${
              isEnabled
                ? css() +
                  ` text-${theme}-normal group-hover:bg-${theme}-btn-hover group-hover:border-${theme}-btn-hover group-active:bg-${theme}-btn-click group-active:border-${theme}-btn-click `
                : ` text-${theme}-disabled border-thin border-${theme}-btn-disabled`
            }
             font-semibold relative`}
      >
        <Corner enabled={isEnabled} />
        {children}
      </button>
    </>
  );
}
